/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaGNVertSecuredConfiguration } from '../shiva-gn-vert-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addSubscriptionContact } from '../fn/subscription-contacts/add-subscription-contact';
import { AddSubscriptionContact$Params } from '../fn/subscription-contacts/add-subscription-contact';
import { getSubscriptionContact } from '../fn/subscription-contacts/get-subscription-contact';
import { GetSubscriptionContact$Params } from '../fn/subscription-contacts/get-subscription-contact';
import { removeContactFromSubscription } from '../fn/subscription-contacts/remove-contact-from-subscription';
import { RemoveContactFromSubscription$Params } from '../fn/subscription-contacts/remove-contact-from-subscription';
import { searchSubscriptionContacts$Any } from '../fn/subscription-contacts/search-subscription-contacts-any';
import { SearchSubscriptionContacts$Any$Params } from '../fn/subscription-contacts/search-subscription-contacts-any';
import { searchSubscriptionContacts$Json } from '../fn/subscription-contacts/search-subscription-contacts-json';
import { SearchSubscriptionContacts$Json$Params } from '../fn/subscription-contacts/search-subscription-contacts-json';
import { SubscriptionContact } from '../models/subscription-contact';
import { SubscriptionContactsPagedList } from '../models/subscription-contacts-paged-list';
import { updateSubscriptionContact } from '../fn/subscription-contacts/update-subscription-contact';
import { UpdateSubscriptionContact$Params } from '../fn/subscription-contacts/update-subscription-contact';


/**
 * All about the custom subscription's contacts
 */
@Injectable({ providedIn: 'root' })
export class SubscriptionContactsService extends BaseService {
  constructor(config: ShivaGNVertSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `searchSubscriptionContacts()` */
  static readonly SearchSubscriptionContactsPath = '/custom/subscriptions/{uid}/contacts/search';

  /**
   * Retrieve a list of contacts of a subscription, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchSubscriptionContacts$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchSubscriptionContacts$Json$Response(params: SearchSubscriptionContacts$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionContactsPagedList>> {
    return searchSubscriptionContacts$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a list of contacts of a subscription, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchSubscriptionContacts$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchSubscriptionContacts$Json(params: SearchSubscriptionContacts$Json$Params, context?: HttpContext): Observable<SubscriptionContactsPagedList> {
    return this.searchSubscriptionContacts$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionContactsPagedList>): SubscriptionContactsPagedList => r.body)
    );
  }

  /**
   * Retrieve a list of contacts of a subscription, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchSubscriptionContacts$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchSubscriptionContacts$Any$Response(params: SearchSubscriptionContacts$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionContactsPagedList>> {
    return searchSubscriptionContacts$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a list of contacts of a subscription, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchSubscriptionContacts$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchSubscriptionContacts$Any(params: SearchSubscriptionContacts$Any$Params, context?: HttpContext): Observable<SubscriptionContactsPagedList> {
    return this.searchSubscriptionContacts$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionContactsPagedList>): SubscriptionContactsPagedList => r.body)
    );
  }

  /** Path part for operation `addSubscriptionContact()` */
  static readonly AddSubscriptionContactPath = '/custom/subscriptions/{uid}/contacts';

  /**
   * Add an already existing contact to a subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addSubscriptionContact()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addSubscriptionContact$Response(params: AddSubscriptionContact$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return addSubscriptionContact(this.http, this.rootUrl, params, context);
  }

  /**
   * Add an already existing contact to a subscription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addSubscriptionContact$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addSubscriptionContact(params: AddSubscriptionContact$Params, context?: HttpContext): Observable<void> {
    return this.addSubscriptionContact$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getSubscriptionContact()` */
  static readonly GetSubscriptionContactPath = '/custom/subscriptions/{uid}/contacts/{contactUid}';

  /**
   * Get a subscription contact.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubscriptionContact()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionContact$Response(params: GetSubscriptionContact$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionContact>> {
    return getSubscriptionContact(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a subscription contact.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSubscriptionContact$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionContact(params: GetSubscriptionContact$Params, context?: HttpContext): Observable<SubscriptionContact> {
    return this.getSubscriptionContact$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionContact>): SubscriptionContact => r.body)
    );
  }

  /** Path part for operation `updateSubscriptionContact()` */
  static readonly UpdateSubscriptionContactPath = '/custom/subscriptions/{uid}/contacts/{contactUid}';

  /**
   * Update a subscription contact.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSubscriptionContact()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSubscriptionContact$Response(params: UpdateSubscriptionContact$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateSubscriptionContact(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a subscription contact.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSubscriptionContact$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSubscriptionContact(params: UpdateSubscriptionContact$Params, context?: HttpContext): Observable<void> {
    return this.updateSubscriptionContact$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `removeContactFromSubscription()` */
  static readonly RemoveContactFromSubscriptionPath = '/custom/subscriptions/{uid}/contacts/{contactUid}';

  /**
   * remove contact from plan.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeContactFromSubscription()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeContactFromSubscription$Response(params: RemoveContactFromSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return removeContactFromSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * remove contact from plan.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeContactFromSubscription$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeContactFromSubscription(params: RemoveContactFromSubscription$Params, context?: HttpContext): Observable<void> {
    return this.removeContactFromSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
